import React, { useState, useEffect, useMemo, useCallback } from 'react';
import PropTypes from "prop-types";
import { OuiFlexGroup, OuiFlexItem } from '../../../../src/components/flex';
import { OuiBadge } from '../../../../src/components/badge';
import { OuiContextMenuPanel, OuiContextMenuItem } from '../../../../src/components/context_menu';
import { OuiButton } from '../../../../src/components/button';
import { OuiPopover } from '../../../../src/components/popover';
export var GuideVersionSelector = ({
  selected
}) => {
  const isLocalDev = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(selected);
  const [options, setOptions] = useState([selected]);
  const onButtonClick = () => {
    setPopoverOpen(!isPopoverOpen);
  };
  const closePopover = () => {
    setPopoverOpen(false);
  };
  const onChange = useCallback(value => e => {
    e.preventDefault();
    closePopover();
    setSelectedOption(value);
    window.location.href = `/${value}`;
  }, []);
  useEffect(() => {
    if (isLocalDev) {
      return;
    }
    fetch('/versions.json').then(response => {
      if (!response.ok) {
        return Promise.reject(response.text());
      }
      return response.json();
    }).then(branches => {
      setOptions(branches);
    }).catch(console.error);
  }, [isLocalDev]);
  const items = useMemo(() => options.map((option, i) => <OuiContextMenuItem key={option} icon={option === selectedOption ? 'check' : 'empty'} href={`/${option}`} onClick={onChange(option)}>
          <OuiFlexGroup direction="row" wrap={false}>
            <OuiFlexItem>v{option}</OuiFlexItem>
            {i === 0 && <OuiFlexItem>
                <OuiBadge>Latest</OuiBadge>
              </OuiFlexItem>}
          </OuiFlexGroup>
        </OuiContextMenuItem>), [onChange, options, selectedOption]);
  const button = <OuiButton size="s" iconType="arrowDown" iconSide="right" color="ghost" minWidth={0} onClick={onButtonClick}>
      v{selectedOption}
    </OuiButton>;
  return <OuiPopover repositionOnScroll button={button} isOpen={isPopoverOpen} closePopover={closePopover} panelPaddingSize="none" anchorPosition="downRight">
      <OuiContextMenuPanel size="s" items={items} />
    </OuiPopover>;
};
GuideVersionSelector.propTypes = {
  selected: PropTypes.string.isRequired
};
try {
  GuideVersionSelector.__docgenInfo = {
    tags: {},
    filePath: '/codebuild/output/src3077135706/src/src-docs/src/components/guide_version_selector/guide_version_selector.tsx',
    description: '',
    displayName: 'GuideVersionSelector',
    methods: [],
    props: {
      selected: {
        defaultValue: null,
        description: '',
        name: 'selected',
        parent: undefined,
        declarations: [{
          fileName: 'src/src-docs/src/components/guide_version_selector/guide_version_selector.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'string'
        }
      }
    },
    extendedInterfaces: []
  };
} catch (e) {}